import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { FormatIndianNumber } from "../utiles/FormatIndianNumber";
import TableLayout from "./TableLayout";
import useLocale from "../locales";
const BussinessLoanTable = ({ showTable, historyData ,shouldGenerateReport,
  setShouldGenerateReport,calcDone}) => {
  const { textData } = useLocale();
  const [reportData, setreportData] = useState([]);

  const { loanAmmount, timePeriod, intrestRate, bussinessEmi } = useSelector(
    (state) => state.bussinessCalculator
  );

  useEffect(() => {
    if (historyData) {
      gnrateHistoryReport();
    } 
  }, [loanAmmount, timePeriod, intrestRate, bussinessEmi, historyData,showTable]);

    useEffect(() => {
      if (shouldGenerateReport) {
        generateReportData();
        setShouldGenerateReport(false);
      }else if (!calcDone) {
    setreportData([]); 
    gnrateHistoryReport();
  }
    }, [shouldGenerateReport,calcDone,historyData]);

  const gnrateHistoryReport = () => {
    if (!Array.isArray(historyData) || historyData.length === 0) {
      return;
    }

    const bussinessData = historyData[0];
    const principal = parseFloat(bussinessData.totalInvestment);
    const annualInterestRate = parseFloat(bussinessData.interestRate) / 100;
    const monthlyInterestRate = annualInterestRate / 12;
    const loanTermYears = parseInt(bussinessData.time) / 12;
    const monthlyPayment = parseFloat(bussinessData.emi);

    let balance = principal;
    const yearlyData = [];
    let totalInterestPaid = 0;
    let totalRepayment = 0;

    for (let year = 1; year <= loanTermYears; year++) {
      let yearlyInterest = 0;
      let yearlyPrincipal = 0;
      const openingBalance = balance;

      for (let month = 1; month <= 12; month++) {
        if (balance <= 0) break;

        const monthlyInterest = balance * monthlyInterestRate;
        const monthlyPrincipal = monthlyPayment - monthlyInterest;

        let actualPrincipal = monthlyPrincipal;
        if (balance < monthlyPrincipal) {
          actualPrincipal = balance;
        }

        yearlyInterest += monthlyInterest;
        yearlyPrincipal += actualPrincipal;
        balance -= actualPrincipal;
      }

      totalInterestPaid += yearlyInterest;
      totalRepayment += yearlyPrincipal + yearlyInterest;

      yearlyData.push({
        year: year,
        openingBalance: openingBalance,
        intrestPaid: yearlyInterest,
        principlePaid: yearlyPrincipal,
        monthlyPayment: monthlyPayment,
        totalrepayment: yearlyPrincipal + yearlyInterest,
        totalInterestPaid: totalInterestPaid,
      });

      if (balance <= 0) break;
    }
    setreportData(yearlyData);
  };

  const generateReportData = () => {
    const principal = parseFloat(loanAmmount);
    const annualInterestRate = parseFloat(intrestRate) / 100;
    const monthlyInterestRate = annualInterestRate / 12;
    const loanTermYears = parseInt(timePeriod);
    const monthlyPayment = parseFloat(bussinessEmi);

    let balance = principal;
    const yearlyData = [];
    let totalInterestPaid = 0;
    let totalRepayment = 0;

    for (let year = 1; year <= loanTermYears; year++) {
      let yearlyInterest = 0;
      let yearlyPrincipal = 0;
      const openingBalance = balance;

      for (let month = 1; month <= 12; month++) {
        if (balance <= 0) break;

        const monthlyInterest = balance * monthlyInterestRate;
        const monthlyPrincipal = monthlyPayment - monthlyInterest;

        let actualPrincipal = monthlyPrincipal;
        if (balance < monthlyPrincipal) {
          actualPrincipal = balance;
        }

        yearlyInterest += monthlyInterest;
        yearlyPrincipal += actualPrincipal;
        balance -= actualPrincipal;
      }

      totalInterestPaid += yearlyInterest;
      totalRepayment += yearlyPrincipal + yearlyInterest;

      yearlyData.push({
        year: year,
        openingBalance: openingBalance,
        intrestPaid: yearlyInterest,
        principlePaid: yearlyPrincipal,
        monthlyPayment: monthlyPayment,
        totalrepayment: yearlyPrincipal + yearlyInterest,
        totalInterestPaid: totalInterestPaid,
      });

      if (balance <= 0) break;
    }

    setreportData(yearlyData);
  };

  const columns = [
    { key: "year", label: textData.tableLabels.year, format: (value) => value },
    {
      key: "openingBalance",
      label: `${textData.tableLabels.openingBalance} (${textData.currency})`,
      format: (value) => `${FormatIndianNumber(Math.round(value))}`,
    },
    {
      key: "intrestPaid",
      label: `${textData.tableLabels.intrestPaid} (${textData.currency})`,
      format: (value) => `${FormatIndianNumber(Math.round(value))}`,
    },
    {
      key: "principlePaid",
      label: `${textData.tableLabels.principlePaid} (${textData.currency})`,
      format: (value) => `${FormatIndianNumber(Math.round(value))}`,
    },
    {
      key: "monthlyPayment",
      label: `${textData.tableLabels.monthlyPayment} (${textData.currency})`,
      format: (value) => `${FormatIndianNumber(Math.round(value))}`,
    },
    {
      key: "totalrepayment",
      label: `${textData.tableLabels.totalrepayment} (${textData.currency})`,
      format: (value) => `${FormatIndianNumber(Math.round(value))}`,
    },
    {
      key: "totalInterestPaid",
      label: `${textData.tableLabels.totalInterestPaid} (${textData.currency})`,
      format: (value) => `${FormatIndianNumber(Math.round(value))}`,
    },
  ];
  return (
    <TableLayout
      showTable={showTable}
      title={`${textData.filterDropDown.businessLoanCalc} ${textData.report}`}
      data={reportData}
      columns={columns}
      analyticsEventName="download_pl_report"
      reportTitle={textData.reportTitle.bussinessLoan}
      fileName="bussiness_loan_detail"
    />
  );
};

export default BussinessLoanTable;
